import React, {Component, useState, useEffect} from 'react'
import {Redirect, Link} from 'react-router-dom';
import UserService from "../../API/user/UserService"
import {Card, Input, Button} from 'antd'
import PropTypes from 'prop-types';

import "./Login.css"
import Navbar from '../../components/layout/Navbar';
import Footer3 from '../../components/layout/Footer3';

const ResetPasswordNewInner = (props) => {
    const [toast, setToast] = useState(null);

    useEffect(() => {
        if (!toast) return;
        const timer = setTimeout(() => setToast(null), 5000);
        return () => clearTimeout(timer);
    }, [toast]);

    return (
        <>
            <Navbar />
            <ResetPasswordNew {...props} setToast={setToast} />
            {toast && (
                <div className="toast-notification-wrapper">
                    <div className={`toast-notification ${toast.type || 'error'}`}>
                        <div>
                            {toast.title && (
                                <div className="toast-notification-title">{toast.title}</div>
                            )}
                            <div>{toast.message}</div>
                        </div>
                        <button
                            type="button"
                            className="toast-notification-close"
                            onClick={() => setToast(null)}
                        >
                            ×
                        </button>
                    </div>
                </div>
            )}
            <Footer3 />
        </>
    );
};

class ResetPasswordNew extends Component {
    constructor(props) {
        super(props)
        
        this.state = {
            email: '',
            password: '',
            password2: '',
            isLoading: false,
            feedback: null,
            redirect: false,
        }
    }
    
    

    static contextTypes = {
        encrypt: PropTypes.func.isRequired,
        decrypt: PropTypes.func.isRequired,
    }

    checkPassword = (password) => {
        if (password > 8) {
            var re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
            return re.test(password);
        } else {
            return false;
        }
    }

    submit = () => {
        this.setState({isLoading: true})
        const data = {
            email: this.props?.location?.state?.email,
            password: this.state.password,
            token: this.props?.location?.state?.token
        }
        if (!this.state.password === this.state.password2 && !this.checkPassword(this.state.password === false)) {
            const msg = "Passwords must match and meet the complexity requirements.";
            this.setState({isLoading: false, feedback: msg})
            this.props.setToast && this.props.setToast({
                type: 'error',
                title: 'Invalid password',
                message: msg,
            });
        } else {
            UserService.updatePassword(data)
                .then((resp) => {
                    this.setState({isLoading: false, feedback: resp?.data?.message || "Password updated"})
                
                    const response = JSON.stringify(resp.data);
                     
                    this.setState({token: resp?.data?.accessToken})
                 
                    const data = this.context.encrypt(response);
                    localStorage.setItem('UserData', data);
                   
                    this.setState({redirect: true})

                })
                .catch((err) => {
                    console.error('Update password error:', err?.response?.data || err);
                    const msg = 'Could not update your password. Please try again later.';
                    this.setState({isLoading: false, feedback: msg});
                    this.props.setToast && this.props.setToast({
                        type: 'error',
                        title: 'Update failed',
                        message: msg,
                    });
                });
        }
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

   
    render() {
        if (this.state.redirect) {
            return <Redirect to={{
                pathname: `/login`,
            }}
            />
        }
        return (
            <div className='auth-page'>
                <div className='auth-card-wrapper'>
                    <Card className='auth-card'>
                        <h1 className='auth-title'>Create New Password</h1>
                        <p className='auth-subtitle'>
                            Enter your new password below
                        </p>

                        <div className='auth-form-group'>
                            <label className='auth-label'>New Password</label>
                            <Input
                                name="password"
                                type='password'
                                onChange={(e) => this.handleChange(e)}
                                className='auth-input'
                                placeholder='Enter new password'
                            />
                        </div>

                        <div className='auth-form-group'>
                            <label className='auth-label'>Confirm Password</label>
                            <Input
                                name="password2"
                                type='password'
                                onChange={(e) => this.handleChange(e)}
                                className='auth-input'
                                placeholder='Confirm new password'
                            />
                        </div>

                        <Button
                            onClick={this.submit}
                            type="primary"
                            className='auth-btn'
                        >
                            {this.state.isLoading ? (
                                <div className="lds-facebook"><div></div><div></div><div></div></div>
                            ) : "Create Password"}
                        </Button>

                        {this.state.feedback && (
                            <p className='auth-feedback'>{this.state.feedback}</p>
                        )}

                        <div className='auth-footer'>
                            Don't have an account? <Link to="/register">Sign Up</Link>
                        </div>
                    </Card>
                </div>
            </div>
        )
    }
}

export default ResetPasswordNewInner;
